<h1 mat-dialog-title>Entrada fuera de tu horario configurado</h1>
<mat-dialog-content>
  <p>
    Tu horario de hoy empieza a las <b>{{ data.scheduled_entry_time }}</b> y estás intentando fichar entrada a las
    <b>{{ data.current_time }}</b
    >, una hora que no tienes configurada.
  </p>

  <p class="warning-text">
    Si fichas entrada sin ajustar tu horario, este tiempo extra no quedará reflejado en tu jornada prevista y
    <b>afectará negativamente a tu KPI</b>.
  </p>

  <p class="info-title">¿Qué puedes hacer?</p>
  <ul class="info-list">
    <li>Puedes <b>adelantar la hora de entrada</b> de la primera franja del día en la excepción horaria de esta semana.</li>
    <li>Si necesitas representar un tramo adicional, puedes <b>crear una franja nueva el mismo día</b> antes de la franja prevista.</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" (click)="manageException()">
    <mat-icon>edit_calendar</mat-icon>
    Gestionar excepción horaria
  </button>
  <button mat-flat-button color="warn" (click)="confirmClockIn()">Fichar entrada igualmente</button>
</mat-dialog-actions>
